import { checkIsDefined } from "@/shared/Preconditions";
import { switchMap } from "rxjs/operators";
const AUTH_REQUIRED = "Authentication is required to get feed.";
export class GetFeedUseCaseImpl {
    constructor(tweetRepository, getUser) {
        this.tweetRepository = tweetRepository;
        this.getUser = getUser;
    }
    run() {
        return this.getUser.run().pipe(switchMap(user => this.getTweetsForUser(user)));
    }
    getTweetsForUser(user) {
        checkIsDefined(user, AUTH_REQUIRED);
        return this.tweetRepository.getTweetsByUserIds([user.id, ...user.following]);
    }
}
